import React, { useContext, useEffect, useRef, useState } from "react";
import { Form } from "react-router-dom";
import Function from "../../../StateContext/Application";
import { Cancel32, Email32, PhoneNumber32, submit } from "../../../../../public/LoginImages/importimages";

const CreateUser = () => {
  const types = useContext(Function);
  const { EmployeeManagement, Roles, DepartmentHandler } = types;

  const [formData, setFormData] = useState({ FullName: "", ProfilePic: "", PhoneNumber: "", Email: "", Password: "", RoleID: "", Role: "", Department_ID: "", Department_Name: "", });

  const [Role, SetRole] = useState([]);
  const [optionrole, SelectedRole] = useState();
  const [DepartmentList, SetDepartment] = useState([]);
  const formdataref = useRef(null)

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    try {
      let data = await Roles("View", null);
      SetRole(data);
      let department = await DepartmentHandler("view", null, null);
      SetDepartment(department);
    } catch (error) {
      console.error(error);
    }
  };

  const handleChange = async (e) => {
    try {
      if (e.target.id === 'Department_Name') {
        let obj = JSON.parse(e.target.value);
        SelectedRole(obj.Department_ID);
        formData.Department_Name = obj.Department_Name;
        formData.Department_ID = obj.Department_ID;
      } else if (e.target.id === 'Role') {
        let obj = JSON.parse(e.target.value);
        formData.Role = obj.Designation;
        formData.RoleID = obj.RoleID;
      } else {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
      }
    } catch (error) {
      console.error(error);
    }
  };

  const Submit = async (e) => {
    e.preventDefault()
    try {
      let data = await EmployeeManagement('Create', formData);
      if (data === true) {
        alert("Employee Created Successfully")
        window.location.reload()
      } else {
        alert("Employee Not Created")
        window.location.reload()
      }
    } catch (error) {
      console.error(error);
    }
  };

  function PasswordManager(e) {
    let input = e.currentTarget.parentNode.children[0]
    let eye = e.currentTarget.parentNode.children[1]
    input.type === 'password' ? input.type = 'text' : input.type = 'password'
    eye.className === "fa-regular fa-eye" ? eye.className = "fa-regular fa-eye-slash" : eye.className = "fa-regular fa-eye"
  }

  const resetData = () => {
    formdataref.current.reset()
    setFormData([])
  }

  return (
    <div style={{ padding: '20px', backgroundColor: 'rgb(246, 248, 252)', maxLength: '94vh', overflowY: 'auto' }}>
      <div >
        <div >
          <Form onSubmit={Submit} ref={formdataref} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <div style={{ marginTop: 20, display: 'grid', gap: '2rem', width: '70vw', border: 'none', boxShadow: '0px 0px 10px', padding: '30px', backgroundColor: 'white', borderRadius: '10px', flexWrap: "wrap", }}>
              <h5>Create Employee</h5>
              <div style={{ display: 'flex', gap: '20px', justifyContent: 'space-evenly' }}>
                <div style={{ display: 'grid' }} className="col-5">
                  <label className='form-label' style={{ fontWeight: '700' }}>Full Name</label>
                  <input type="text" className="form-control" name="FullName" value={formData.FullName} onChange={handleChange} required placeholder="Enter Full Name Here" />
                </div>
                <div style={{ display: 'grid' }} className="col-5">
                  <label className="form-label" style={{ fontWeight: '700' }}> Phone Number </label>
                  <div style={{ display: 'flex', alignItems: 'center', position: 'relative' }}>
                    <input type="tel" pattern="\d{10}" minLength="10" maxLength="10" className="form-control" name="PhoneNumber" value={formData.PhoneNumber} onChange={handleChange} onInput={(e) => { let enteredValue = e.target.value; enteredValue = enteredValue.slice(0, 10).replace(/\D/g, ""); e.target.value = enteredValue }} placeholder="Enter Phone Number Here" style={{ paddingRight: '35px' }} /><img src={PhoneNumber32} alt="Phone Icon" style={{ position: 'absolute', right: '10px', width: '20px', height: '20px' }} />
                  </div>
                </div>
              </div>
              <div style={{ display: 'flex', gap: '20px', justifyContent: 'space-evenly' }}>
                <div style={{ display: 'grid' }} className="col-5">
                  <label className='form-label' style={{ fontWeight: '700' }}>Email</label>
                  <div style={{ display: 'flex', alignItems: 'center', position: 'relative' }}>
                    <input type="email" className="form-control" name="Email" value={formData.Email} onChange={handleChange} placeholder="Enter Email Here" />
                    <img src={Email32} style={{ position: 'absolute', right: '10px', width: '20px', height: '20px' }} />
                  </div>
                </div>
                <div style={{ display: 'grid' }} className="col-5">
                  <label className="form-label" style={{ fontWeight: '700' }}>Password</label>
                  <div style={{ display: 'flex', alignItems: 'center', position: 'relative' }}>
                    <input type="password" className="form-control" name="Password" value={formData.Password} onChange={handleChange} placeholder="Enter Password Here" />
                    <i style={{ display: 'flex', alignItems: 'center', position: 'absolute', right: '10px', cursor: 'pointer' }} className="fa-regular fa-eye" onClick={(e) => PasswordManager(e)}></i>
                  </div>
                </div>
              </div>
              <div style={{ display: 'flex', gap: '20px', justifyContent: 'space-evenly' }}>
                <div style={{ display: 'grid' }} className="col-5">
                  <label className='form-label' style={{ fontWeight: '700' }}>Select Department</label>
                  <select className="form-control" id="Department_Name" onChange={(e) => handleChange(e)} >
                    <option value={false}>Select Department</option>
                    {DepartmentList.map((e) => {
                      return (
                        <option key={e.Department_ID} value={JSON.stringify(e)}>{e.Department_Name} </option>
                      );
                    })}
                  </select>
                </div>
                <div style={{ display: 'grid' }} className="col-5">
                  <label className='form-label' style={{ fontWeight: '700' }}>Role</label>
                  <select className="form-control" id="Role" onChange={(e) => handleChange(e)}>
                    <option value={false}>Selected Role</option>
                    {Role.map((e) => {
                      if (optionrole === e.Department_ID) {
                        return (
                          <option key={e.RoleID} value={JSON.stringify(e)}>{e.Designation}</option>
                        );
                      }
                    })}
                  </select>
                </div>
              </div>
              <div style={{ display: 'flex', justifyContent: 'center', gap: '10px', padding: '2.5rem' }}>
                <button type="submit" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: "20px", width: "7rem", height: "2.5rem", backgroundColor: '#502eff', border: 'none', fontSize: '17px', gap: '4px' }}><img src={submit} style={{ width: '1.2rem', paddingBottom: '3px', fontSize: '15px' }} />Submit </button>
                <button onClick={resetData} type='button' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: "20px", width: "7rem", height: "2.5rem", backgroundColor: 'red', border: 'none', fontSize: '17px', gap: '4px' }}><img src={Cancel32} style={{ width: '1.2rem', }} /> Cancel</button>
              </div>
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default CreateUser;
